import React from 'react';

/**
 * Reusable CTA section block.
 */
const CtaSection = ({ title, subtitle, children }) => {
  return (
    <div className="cta-section">
      <h2 className="h2 mb-4" style={{ color: '#fff' }}>{title}</h2>
      {subtitle && (
        <p className="mb-8" style={{ color: 'rgba(255,253,249,0.8)', maxWidth: 480, marginInline: 'auto' }}>
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

export default CtaSection;
